import { render, staticRenderFns } from "./mobileheader.vue?vue&type=template&id=34a31ada&"
import script from "./mobileheader.vue?vue&type=script&lang=js&"
export * from "./mobileheader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports